import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaBookmark } from "react-icons/fa6";
import { FiLogOut } from "react-icons/fi";
import { FaUserCircle, FaHome } from "react-icons/fa";
import Logo from '../images/logo.png';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { buildApiUrl } from "../utils/api";

function ClientMenu() {
    const [userName, setUserName] = useState('');
    const navigate = useNavigate();
    const location = useLocation(); // Get current location

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const userResponse = await axios.get(buildApiUrl('/api/client/clientDetail'), {
                        headers: { Authorization: `Bearer ${token}` }
                    });

                    if (userResponse.data && userResponse.data.user) {
                        setUserName(userResponse.data.user.name);
                    } else {
                        console.error("User data not found in response");
                    }
                }
            } catch (error) {
                console.error('Error fetching user details:', error);
            }
        };

        fetchUserDetails();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userType');
        navigate('/clientLogin');
    };

    return (
        <div className="menubar-client mt-4 shadow">
            <div className="logo">
                <img src={Logo} alt="logo" />
            </div>
            <div className="menus">
                <ul>
                    <li>
                        <FaHome />
                        <Link
                            to="/clientDetails"
                            style={{
                                textDecoration: "none",
                                color: "#000",
                                fontWeight: location.pathname === '/clientDetails' ? 'bold' : 'normal',
                                // backgroundColor: location.pathname === '/clientDetails' ? '#f0f0f0' : 'transparent'
                            }}
                        >
                            Home Page
                        </Link>
                    </li>
                    <hr />
                    <li>
                        <FaBookmark />
                        <Link
                            to="/clientDetails/requestDetail"
                            style={{
                                textDecoration: "none",
                                color: "#000",
                                fontWeight: location.pathname === '/clientDetails/requestDetail' ? 'bold' : 'normal',
                                // backgroundColor: location.pathname === '/clientDetails/requestDetail' ? '#f0f0f0' : 'transparent'
                            }}
                        >
                            Request Details
                        </Link>
                    </li>
                    <hr />
                    <li onClick={handleLogout} style={{ cursor: "pointer" }}>
                        <FiLogOut /> Logout
                    </li>
                </ul>
            </div>
            <div className="currentUser" style={{ backgroundColor: "#E0A75E", height: "28px" }}>
                <h6><FaUserCircle /> Hello, {userName || "Someone"}</h6>
            </div>
        </div>
    );
}

export default ClientMenu;
